import "@babel/polyfill";
import Vue from "vue";
import "normalize.css/normalize.css"; // CSS重置的现代替代方法
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/index.scss"; // 全局css
import App from "./App";
import store from "./store";
import router from "./router";
import "@/icons"; // icon
import "@/permission"; // 权限控制
import common from "./utils/common"; // 自定义js
import echarts from "echarts";
import { message } from "./utils/message.js"; //防止重复点击重复弹出message弹框
import Print from "./utils/print.js"; //打印
import htmlToPdf from "./utils/htmlToPdf"; //将界面导出pdf
import userBtnPer from "./utils/userBtnPer"; //用户按钮权限
import printNb from "vue-print-nb";
import insuplc from "@/components/select/insuplc.vue";
import basePage from "@/components/BasePage";
import Pagination from "@/components/Pagination";
import { download, downloadGet } from "@/utils/request";



//百度富文本配置相关
import "../public/static/ueditor/ueditor.config.js";
import "../public/static/ueditor/ueditor.all.min.js";
import "../public/static/ueditor/lang/zh-cn/zh-cn.js";
import { settings } from "nprogress";

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.component("insuplc", insuplc);

Vue.directive("select-blur", {
  bind(el, binding) {
    let inputDom = el.getElementsByTagName("input")[0];
    if (!inputDom) return;
    let isOpen = false;
    inputDom.addEventListener("focus", function(event) {
      if (isOpen) {
        inputDom.blur();
        isOpen = false;
      } else {
        isOpen = true;
      }
    });
  }
});

Vue.use(ElementUI);
Vue.use(Print); //打印
Vue.use(htmlToPdf); //将界面导出pdf
Vue.use(printNb); //注册
Vue.component("basePage", basePage);
Vue.component("Pagination", Pagination);

Vue.prototype.download = download;
Vue.prototype.downloadGet = downloadGet;

Vue.prototype.$common = common; // 自定义js
Vue.prototype.$echarts = echarts; // echarts
Vue.prototype.$message = message; //引用message要在Vue.use(ElementUI)后面，不然没有效果
Vue.config.productionTip = false;
Vue.prototype.userBtnPer = userBtnPer; //用户按钮权限


new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
